import React from 'react';

import { ActivityIndicator, StyleSheet, View } from 'react-native';

import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

export const AgeAssurancePendingScreen = () => (
  <View
    accessibilityLabel={t('ageAssuranceChecking', 'Checking age eligibility')}
    accessibilityLiveRegion="polite"
    style={styles.container}
    testID="age-assurance-pending"
  >
    <ActivityIndicator size="large" color={primitive.$fieryRed} />
    <Typography textAlign="center">
      {t('ageAssuranceChecking', 'Checking age eligibility')}
    </Typography>
  </View>
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: primitive.$mayoEggWhite,
    flex: 1,
    gap: spacing.$4,
    justifyContent: 'center',
    padding: spacing.$6,
  },
});
